
import {  GetJobPostsByID, GetJobRoles, GetListOfVendorsByEmployeeID, sitewebhookURL, UpdateJobPosts } from "../apiconstants/constants.js";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm,Controller } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import { Link, useLocation} from "react-router-dom";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor.js";
import Select from 'react-select';
import { useCountry } from "../contexts/countrycodecontext.js";
import LoadingSpinner from "../helpers/loadingspinner.js";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const HomeEditJobPost = () => {
  
  let query = useQuery();
  const jobpost = query.get("jobpost");
   const Guid = query.get("userguid"); 
 const selectedCountry = query.get("countryid");
  const vendorid = query.get("vendorid");
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const { register, handleSubmit, control,setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const[jobpostid,setJobPostid] = useState();
    const [jobRoles, setJobRoles] = useState([]);
    const [jobType,setjobtype] = useState([
    {statusID:"1",statusName:"Work from Home"},
    {statusID:"2",statusName:"Work from Office"},
    {statusID:"3",statusName:"Hybrid"}])
   const [clientData, setClientData] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
     const [selectedJobRoleId, setSelectedJobRoleId] = useState("");
    const [showPreview, setShowPreview] = useState(false);
         const [outreach_Status_Type,setOutreach_Status_type] = useState([
           {status:"Not Required",typeName:"Not Required"},
           {status:"Not Started",typeName:"Not Started"},
            {status:"In-progress",typeName:"In-progress"},
            {status:"Completed",typeName:"Completed"}]);
                const [outreach_Type,setOutreach_type] = useState([
                        {status:"Candidates",typeName:"Candidates"},
                        {status:"Benchsales",typeName:"Benchsales"},
                        {status:"Both",typeName:"Both"}]);
 const token = localStorage.getItem("jwtToken"); 
    const fetchJobRoles = async () => {
        setIsLoading(true);
      const getApiUrl =  `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
       await Axios.get(getApiUrl).then((response) => {
          setJobRoles(response.data);
      }).catch((error) => {
          console.error("Error fetching job roles", error);
      });
  };
  const GetVendorsList =async () => {
    const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  await  Axios.get(GetapiUrl)
      .then((result) => {
        setClientData(result.data);
      }).catch((error) => {
        console.log("Error" + error);
      });
  };

  
  const jobRoleOptions = jobRoles.map((item) => ({
    value: item.jobRoleId,
    label: item.jobRole
  })); 

const GetJobPostByID = async () => {
  const GetapiUrl = `${GetJobPostsByID.APIURL}?JobPostID=${jobpost}`;

  try {
    const response = await Axios.get(GetapiUrl,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const data = response.data[0];

    setJobPostid(data.jobPostID);
    setSelectedJobRoleId(data.jobRoleID);
    setValue("jobPostID", data.jobPostID);
    setValue("jobRoleID", data.jobRoleID);
    setValue("title", data.title);
    setValue("positions", data.positions);
    setValue("location", data.location);
    setValue("jobType", data.jobType);
    setValue("billRate", data.billRate);
    setValue("payRate", data.payRate);
    setValue("endClient", data.endClient);
    setValue("outreach_Status", data.outreach_Status);
      setValue("outreach_Type", data.outreach_Type);
    // sanitize API data and enforce Arial/12px
const sanitized = data.jobDescription
  ? data.jobDescription
      .replace(/font-family:[^;"]+;?/gi, "")
      .replace(/font-size:[^;"]+;?/gi, "")
  : "";

const wrapped = `<div style="font-family: Arial; font-size: 12px;">${sanitized}</div>`;

setValue("jobDescription", wrapped);

    setValue("status", data.status);
    setValue("rolesAndResponsibilities", data.rolesAndResponsibilities);
    setValue("startDate", data.startDate.split('T')[0]);
    setValue("endDate", data.endDate.split('T')[0]);

    // ✅ Set selected client by vGuid match
  const matchedClient = clientData.find(client => client.vGuid === data.vGuid);
if (matchedClient) {
  setValue(
    "selectedClient",
    JSON.stringify({
      clientName: matchedClient.vendorName,
      vGuid: matchedClient.vGuid,
    }),
    { shouldValidate: true, shouldDirty: true } // ✅ Ensures React Hook Form re-registers the update
  );
}

  } catch (error) {
    console.error("Error fetching job post by ID", error);
  } finally {
    setIsLoading(false);
  }
};

  const onSubmit = (data, e) => {
    e.preventDefault();
    updateData(data);
  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }
  const updateData = async(data) => {
    console.log("109",data)
     const { clientName, vGuid } = JSON.parse(data.selectedClient);
    const params={
      "jobPostID": jobpostid,
      "title": data.title,
      "positions": data.positions,
      "location" : data.location,
      "jobType": data.jobType,
      "clientName": clientName,
      "billRate": data.billRate,
      "payRate":data.payRate,
      "endClient":data.endClient,
      "jobDescription": data.jobDescription,
      "rolesAndResponsibilities" : null,
      "startDate" : data.startDate,
      "endDate" : data.endDate,
      "jobRoleID" : data.jobRoleID,
      "status": data.status,
      "countryID":selectedCountry,
      "outreach_Status" : data.outreach_Status,
       "outreach_Type" : data.outreach_Type,
      vGuid:vGuid
    }
 apiUrl = UpdateJobPosts.APIURL;
 Axios.post(apiUrl, params,
    { headers: { Authorization: `Bearer ${token}` } }
 )
   .then((result) => {
          if (result.data === 'Updated successfully') {
       const n8nWebhookUrl =sitewebhookURL; // replace with your n8n URL
        fetch(n8nWebhookUrl, { method: "POST" }); // no need to await or handle response
     Swal.fire({
         position: 'center',
         icon: 'success',
         title: 'Updated Successfully ',
         showConfirmButton: false,
         timer: 5000
       })
     }
     else {
       // toast.error('Issue with data format', {autoClose:5000})
       Swal.fire({
         position: 'center',
         icon: 'error',
         title: 'Add correct Details',
         showConfirmButton: false,
         timer: 5000
       })
     }

   }).catch(
     function (error) {
       console.log("Error" + error)
     })

}

useEffect(() => {
  const fetchInitialData = async () => {
    try {
      setIsLoading(true);
      await Promise.all([fetchJobRoles(), GetVendorsList()]);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  fetchInitialData();
}, [Guid, selectedCountry]);

// 2️⃣ Once vendor list and job roles are loaded, then load job post
useEffect(() => {
  if (clientData.length > 0 && jobRoles.length > 0 && jobpost) {
    console.log("✅ Loading job post now...");
    GetJobPostByID();
  }
}, [clientData, jobRoles, jobpost]);

// 3️⃣ If vendorid comes from URL, auto-select that client
useEffect(() => {
  if (vendorid && clientData.length > 0) {
    const matchedVendor = clientData.find(v => v.vGuid === vendorid);
    if (matchedVendor) {
      setValue("selectedClient", JSON.stringify({
        clientName: matchedVendor.vendorName,
        vGuid: matchedVendor.vGuid
      }));
      console.log("✅ Vendor set from URL:", matchedVendor.vendorName);
    }
  }
}, [vendorid, clientData]);

  return (
      <section>
   {
              isLoading ? <center><LoadingSpinner /></center> :
                    <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
 
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Edit Job Post</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
 <div className="row p-3">
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>)}>
                                                <Controller
      name="jobRoleID"
      control={control}
      rules={{ required: "Job Role is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={jobRoleOptions}
          value={jobRoleOptions.find(option => option.value == selectedJobRoleId)} 
          onChange={(selectedOption) => {
            field.onChange(selectedOption.value); // Store jobRoleId in form
            setSelectedJobRoleId(selectedOption.value); // Update local state
          }}

          placeholder="Select Job Role"
          className={`basic-form ${errors.jobRoleID ? 'is-invalid' : ''}`}
          styles={{
            control: (provided, state) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              borderColor: errors.jobRoleID ? 'red' : provided.borderColor
            })
          }}
        />
      )}
    />
   
                                                </OverlayTrigger>
                                                {errors.jobRoleID && (
      <div className="invalid-feedback d-block">{errors.jobRoleID.message}</div>
    )}                                            </div>
                                        </div>
                                        
                                        {/* <div className="row mt-0 p-2">
                                            <div className="col-12">
                                                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Test Type</Tooltip>)}>
                                                    <select {...register("testTypeID", { required: "Test Type Required" })} className={`form-control basic-form mt-3 ${errors.testTypeID ? 'is-invalid' : ''}`} style={{ height: 50, borderRadius: 15 }}>
                                                        <option value="">Select Test Type</option>
                                                        {
                                                            testTypes.map((item, index) => (
                                                                <option key={index} value={item.testTypeID}>{item.testType}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </OverlayTrigger>
                                                <div className="invalid-feedback"> {errors.testTypeID?.message}</div>
                                            </div>
                                        </div> */}
                  <div className="row mt-0 p-2">
                  <div className="col-12">                      
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Title</Tooltip>)}>
                <input type="text" name="title"  {...register("title", { required: "Title Required" })} placeholder="Title" className={`form-control basic-form  ${errors.title ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.title?.message}</div>
              </div></div>

              <div className="row mt-0 p-2">
              <div className="col-12">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Positions</Tooltip>)}>
                <input type="number" name="positions"  {...register("positions", { required: "Positions Required" })} placeholder="Positions" className={`form-control basic-form  ${errors.positions ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.positions?.message}</div>
              </div>
              </div>

              <div className="row mt-0 p-2">
              <div className="col-12">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Location</Tooltip>)}>
                <input type="text" name="location"  {...register("location", { required: "location Required" })} placeholder="location" className={`form-control basic-form  ${errors.location ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.location?.message}</div>
              </div>
              </div>

              <div className="row mt-0 p-2">
    <div className="col-12">                                             
  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Job type</Tooltip>)}>    

<select  {...register("jobType", { required: "Job Type Required" })} className={`form-control basic-form mt-3 ${errors.jobType ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15}}  >
<option value="">Select Job Type</option>
{
jobType.map((item,index)=>
{
return(

<option key={index}  value={item.statusName}>{item.statusName}</option>

);
}

)
}
</select>
</OverlayTrigger>        
{ <div className="invalid-feedback">{errors.jobType?.message}</div> }

              </div>
              </div>    

              <div className="row mt-0 p-2">
                  <div className="col-12">                      
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Client Name</Tooltip>)}>          
          
<select
  {...register("selectedClient", { required: "Client Name Required" })}
  className={`form-control mt-1 ${errors.selectedClient ? 'is-invalid' : ''}`}
  style={{ height: 50, borderRadius: 15, fontSize: 12 }}
>
  <option value="">Select Client Name</option>
  {clientData.map((item, index) => (
    <option
      key={index}
      value={JSON.stringify({ clientName: item.vendorName, vGuid: item.vGuid })}
    >
      {item.vendorName} - {item.vendorCompanyName}
    </option>
  ))}
</select>

              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.clientName?.message}</div>
              </div></div>
                 <div className="row mt-0 p-2">
                                <div className="col-12">                      
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> End Client Name</Tooltip>)}>
                              <input type="text" name="endclient"  {...register("endClient")} placeholder = "End Client Name" className={`form-control basic-form`} />
                            </OverlayTrigger>
                         
              </div></div>
  <div className="row mt-0 p-2">
                  <div className="col-12">                      
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {selectedCountry == 1 ? 'Expected CTC' : 'Bill Rate'}</Tooltip>)}>
                <input type="text" name="billRate"  {...register("billRate", { required: "Bill Rate Required" })} placeholder={selectedCountry == 1 ? 'Expected CTC' : 'Bill Rate'} className={`form-control basic-form  ${errors.billRate ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.billRate?.message}</div>
              </div></div>
               <div className="row mt-0 p-2">
              <div className="col-12">                      
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {selectedCountry == 1 ? ' Current CTC' : 'Pay Rate'}</Tooltip>)}>
                              <input type="text" name="payRate"  {...register("payRate")} placeholder= {selectedCountry == 1 ? ' Current CTC' : 'Pay Rate'}  className={`form-control basic-form`} />
                            </OverlayTrigger>
                            </div></div>

            
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                 
<Controller
  control={control}
  name="jobDescription"
  rules={{
    required: { value: true, message: "Job Description Required" },
  }}
  render={({ field: { onChange, onBlur, value, ref } }) => {
  const handleEditorChange = (content) => {
 let sanitized = content
    // force remove inline fonts/sizes
    .replace(/font-family:[^;"]+;?/gi, "")
    .replace(/font-size:[^;"]+;?/gi, "")
    // remove empty paragraphs
    .replace(/<p[^>]*>(\s|&nbsp;)*<\/p>/gi, "")
    // unwrap <p> or <div> (with any attrs) inside list items
    .replace(/<li[^>]*>\s*(?:<p[^>]*>|<div[^>]*>)(.*?)<\/(?:p|div)>\s*<\/li>/gis, "<li>$1</li>")
    // remove a leading <br> inside li
    .replace(/<li[^>]*>\s*<br\s*\/?>\s*/gi, "<li>")
    // collapse multiple <br> into one
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>");


  // wrap with Arial/12px
  const wrapped = `<div style="font-family: Arial; font-size: 12px;">${sanitized}</div>`;
  onChange(wrapped);
};


    return (
      <div>
        {/* Label + Button in one row */}
        <div className="d-flex align-items-center mb-2">
          <label style={{ color: "#00a7ac", margin: 0, }}>
            Job Description
          </label>
        <OverlayTrigger
  placement="right"
  overlay={<Tooltip id="preview-tooltip">
    {showPreview ? "Hide Preview" : "Show Preview"}
  </Tooltip>}
>
  <button
    type="button"
    className="btn btn-outline-primary btn-sm ml-3"
    onClick={() => setShowPreview(!showPreview)}
  >
    {showPreview ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
  </button>
</OverlayTrigger>

        </div>

        {/* Editor */}
        <WYSIWYGEditor
          onChange={handleEditorChange}
          onBlur={onBlur}
          value={value}
          ref={ref}
          inputExtraProps={{
            required: true,
            style: { fontFamily: "Arial", fontSize: "12px" },
          }}
        />
        {errors.jobDescription && (
          <p
            style={{
              marginTop: "0.25em",
              fontSize: "80%",
              color: "#dc3545",
            }}
          >
            {errors.jobDescription.message}
          </p>
        )}

        {/* Preview Box */}
        {showPreview && value && (
          <div
            className="mt-3 p-3 border rounded"
            style={{ background: "#fafafa" }}
          >
            <h6 style={{ color: "#00a7ac" }}>Preview:</h6>
            <div
              style={{ fontFamily: "Arial", fontSize: "12px" }}
              dangerouslySetInnerHTML={{ __html: value }}
            />
          </div>
        )}
      </div>
    );
  }}
/>
                                            </div>
                                        </div>
      <div className="row mt-0 p-2">
      <div className="col-12">
       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Start Date</Tooltip>)}>
                <input type="date" title="" name="startDate" {...register("startDate", { required: "Start Date Required" })} placeholder="Start Date" className={`form-control basic-form ${errors.startDate ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
            
              
              <div className="invalid-feedback">{errors.startDate?.message}</div>
              </div>
              </div>
            
              <div className="row mt-0 p-2">
              <div className="col-12">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>End Date</Tooltip>)}>
                <input type="date" title="" name="endDate" {...register("endDate", { required: "End Date Required" })} placeholder="End Date" className={`form-control basic-form ${errors.endDate ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.endDate?.message}</div>
              

              </div>
              </div>
              <div className="row mt-0 p-2">
              <div className="col-12">
          
              <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Post Status</Tooltip>)}>
<select  {...register("status", { required: "Status Required" })} className={`form-control basic-form ${errors.status ? 'is-invalid' : ''}`} style={{height:50 ,borderRadius:15}} >
<option value="">Select Post Status</option>
<option value="Active">Active</option>
<option value="On Hold">On Hold</option>
<option value="Closed">Closed</option>
</select>
    </OverlayTrigger>  
                            <div className="invalid-feedback"> {errors.status?.message}</div>

    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Outreach Status
    </Tooltip>)}>
    <select  {...register("outreach_Status")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}} >
    <option value="">Select Outreach Status</option>
    {
      outreach_Status_Type.map((item,index)=>
      {
        return(
    
       <option key={index}  value={item.status}>{item.status}</option>
    
        );
      }
      
      )
    }
    </select>
    </OverlayTrigger>  
                 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Outreach Type</Tooltip>)}>
    
         <select
      {...register("outreach_Type")}
      className={`form-control mt-3`}
      style={{ height: 50, borderRadius: 15, fontSize: 12 }}
    >
          <option value="">Select Outreach Type</option>
    
      {outreach_Type.map((item, index) => (
        <option key={index} value={item.status}>
          {item.typeName}
        </option>
      ))}
    </select>
    </OverlayTrigger>
                                    </div>
                                    </div>  
                                            </div>
                                      
         
          <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/ListOfJobPosts"> 
             <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Update
              </button> &nbsp;&nbsp;&nbsp;
            </div>
        </div>
        </form>
        </div></div>
                </div>
}
  </section>
  );
}

export default HomeEditJobPost;